import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    NumberField,
    ReferenceField,
    usePermissions,
    useResourceContext,
    EditButton,
    Filter,
    SearchInput,
    ReferenceInput,
    SelectInput,
    DateField,
    BooleanField
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const FeeStructureFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <ReferenceInput
            source='branch_id'
            reference='branch'
            link={false}
            alwaysOn
        >
            <SelectInput optionText='branch_name' label="Branch" />
        </ReferenceInput>
        <ReferenceInput
            source='program_id'
            reference='program'
            link={false}
        >
            <SelectInput optionText='program_name' label="Program" />
        </ReferenceInput>
        <ReferenceInput
            source='section_id'
            reference='section'
            link={false}
        >
            <SelectInput 
                optionText='section' 
                label="Section"
                
                emptyText="All Sections"
            />
        </ReferenceInput>
        <SelectInput 
            source='board' 
            label="Board" 
            choices={[
                { id: 'RBSE', name: 'RBSE' },
                { id: 'CBSE', name: 'CBSE' },
                { id: 'IGCSE', name: 'IGCSE' },
            ]} 
        />
    </Filter>
);

export const FeeStructureList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    // Use utility function to process permissions with role-based restrictions
    const propsObj = processPermissions(permissions, resource);
    
    // Enable bulk actions only for admin users (role_id = 1)
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="Fee Structures" 
                {...props} 
                {...propsObj}
                filters={<FeeStructureFilter />}
                sort={{ field: 'id', order: 'DESC' }}
            >
                <Datagrid rowClick={propsObj.hasEdit ? 'edit' : false} bulkActionButtons={allowBulkActions ? undefined : false}>
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <ReferenceField source="branch_id" reference="branch" label="Branch" link={false}>
                        <TextField source="branch_name" />
                    </ReferenceField>
                    <ReferenceField source="program_id" reference="program" label="Program" link={false}>
                        <TextField source="program_name" />
                    </ReferenceField>
                    <ReferenceField source="class_id" reference="genere" label="Class" link={false}>
                        <TextField source="class_name" />
                    </ReferenceField>
                    <ReferenceField 
                        source="section_id" 
                        reference="section" 
                        label="Section" 
                        link={false}
                        emptyText="All Sections"
                    >
                        <TextField source="section" />
                    </ReferenceField>
                    <TextField source="board" label="Board" />
                    <NumberField source="registration_fee" label="Registration" options={{ style: 'currency', currency: 'INR' }} />
                    <NumberField source="study_material_fee" label="Study Material" options={{ style: 'currency', currency: 'INR' }} />
                    <NumberField source="deliverable_fee" label="Deliverable" options={{ style: 'currency', currency: 'INR' }} />
                    <NumberField source="tech_support_fee" label="Tech Support" options={{ style: 'currency', currency: 'INR' }} />
                    <NumberField source="tuition_fee" label="Tuition" options={{ style: 'currency', currency: 'INR' }} />
                    <NumberField source="total_fee" label="Total Fee" options={{ style: 'currency', currency: 'INR' }} />
                    <TextField source="installment_count" label="Installments" />
                    <DateField source="effective_from" label="Effective From" />
                    <DateField source="effective_to" label="Effective To" />
                    <BooleanField source="is_active" label="Active" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
